import { initializeApp } from 'firebase/app';
import {
    getAuth,
    GoogleAuthProvider,
    signInWithPopup,
    RecaptchaVerifier,
    PhoneAuthProvider,
    PhoneMultiFactorGenerator,
    multiFactor,
    getMultiFactorResolver
} from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBjjGRirr3eAnuihO418dtKVI-FxTJCttI",
    authDomain: "ohanaauthentication.firebaseapp.com",
    projectId: "ohanaauthentication",
    storageBucket: "ohanaauthentication.firebasestorage.app",
    messagingSenderId: "22372468653",
    appId: "1:22372468653:web:93fdfca17fce66bc264324"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

export {
    RecaptchaVerifier,
    PhoneAuthProvider,
    PhoneMultiFactorGenerator,
    multiFactor,
    getMultiFactorResolver,
    signInWithPopup
};
